// Lista de IDs de los triggers
const headerDrawerTriggers = [
  'HeaderDrawer-preguntas-frecuentes',
  'HeaderDrawer-encuentra-fiido®'
];

headerDrawerTriggers.forEach(id => {
  const trigger = document.getElementById(id);
  if (!trigger) return; // si no existe, saltar

  trigger.addEventListener('click', () => {
    const headerDrawer = document.querySelector('header-drawer');
    const details = headerDrawer.querySelector('details');
    const summaryElement = headerDrawer.querySelector('summary');

    if (headerDrawer.mainDetailsToggle.hasAttribute('open')) {
      headerDrawer.closeMenuDrawer(undefined, summaryElement);
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-tablet');
    } else {
      headerDrawer.openMenuDrawer(summaryElement);
    }
  });
});